import { BReactComponent } from 'blocks-cloud/b-react-component';
import { TreeConnected } from 'reactApp/ui/TreeComponent/TreeComponent';
import { handleGoTo } from 'reactApp/ui/TreeComponent/TreeComponent.helpers';
import { sendGa } from 'reactApp/utils/ga';

export default function (app) {
    const navMenuPlaceholder = document.querySelector('#reactNavMenu');

    if (!navMenuPlaceholder) {
        return null;
    }

    const newNavMenu = new BReactComponent({
        ReactComponent: TreeConnected,
        renderMode: 'append',
    });

    newNavMenu.renderTo(navMenuPlaceholder, { props: { onClick: handleGoTo, gaCategory: 'leftnav' } });

    sendGa('lm', 'show');

    return null;
}
